import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface ImportedUsersErrorStateProps {
  error: Error;
  onRetry: () => void;
}

export const ImportedUsersErrorState = ({ error, onRetry }: ImportedUsersErrorStateProps) => {
  return (
    <div className="space-y-4">
      <div className="text-red-600 p-4 border border-red-200 rounded-lg">
        <h3 className="font-semibold">Error loading import records</h3>
        <p className="text-sm mt-1">{error.message}</p>
        <Button 
          onClick={onRetry} 
          variant="outline" 
          size="sm" 
          className="mt-2"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Retry
        </Button>
      </div>
    </div>
  );
};